import { render } from "./ToolsView.vue?vue&type=template&id=4de001bf"
import script from "./ToolsView.vue?vue&type=script&lang=js"
export * from "./ToolsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__